// How a feature/area row gets its name — shared by the Features sheet (one
// row per raw feature) and the Areas sheet (one row per baked section, split
// further by level), so the same geometry reads the same way on both.

/** The switch column both sheets carry. Not a field on the feature at all —
 *  this app's own, and it drives the map rather than the project. Shared so
 *  both sheets' Show columns are literally the same field name. */
export const SHOW_FIELD = '__show';

/** An opaque auto-assigned id, never something a person typed — Giraffe's own
 *  `buildingID` reads as one of these until someone actually names the
 *  building, and a column of them is noise, not information. */
const GUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

function isGuid(value: string): boolean {
  return GUID_RE.test(value.trim());
}

/**
 * Usage, then the block's own name if the feature places one, then the
 * feature's own Building ID if Giraffe (or someone) actually named the
 * building — e.g. "Residential 1B1Ba Building A", "Retail Building B",
 * "Retail BlockName", "Road". Each part is optional; usage alone, or "No
 * Usage" when even that is missing, is still a perfectly good label.
 */
export function featureLabel(usage: unknown, buildingId: unknown, blockName?: string): string {
  const usageText = typeof usage === 'string' ? usage.trim() : '';
  const parts = [usageText !== '' ? usageText : 'No Usage'];
  if (typeof blockName === 'string' && blockName.trim() !== '') parts.push(blockName.trim());
  if (typeof buildingId === 'string' && buildingId.trim() !== '' && !isGuid(buildingId)) {
    parts.push(buildingId.trim());
  }
  return parts.join(' ');
}
